var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"woocommerce-notices-wrapper"},[_c('div',{staticClass:"woocommerce-message",attrs:{"id":"notice","role":"alert"}},[_c('i',{staticClass:"fa fa-times",on:{"click":_vm.unset}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }